import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "cerrix-error-label",
    imports: [],
    template: "<ng-content></ng-content>",
    styleUrl: "./cerrix-error-label.component.scss",
    encapsulation: ViewEncapsulation.None,
    host: {
        "(click)": "$event.stopPropagation()",
    },
})
export class CerrixErrorLabelComponent {}
